var render = function render(){var _vm=this,_c=_vm._self._c;return _c('group-form',{attrs:{"group":_vm.newGroup,"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }